<template>
  <!-- modalContents__object05：：会員登録フォーム・その３ -->
  <div class="modalContents__object05" data-modalContents="signup03">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
          <h2 class="text-center">PAYMENT</h2>
          <form id="signup03_form" class="row no-gutters">
            <h3 class="col-12">■ お支払い方法 <span v-if="errors.none" class="error_message text-danger">{{ errors.none }}</span></h3>
            <!-- 支払い方法選択 -->
            <div class="col-6 row no-gutters modalContents__object05--payment01">
              <div class="col-md-2 col-sm-3 col-4">
                <input type="radio" name="payment" id="payment01" value="credit" v-model='payment_type'>
                <label for="payment01" aria-hidden="true"></label>
              </div>
              <label class="col-md-10 col-sm-9 col-8" for="payment01">
                <p class="text-left">カード決済</p>
              </label>
            </div>
            <div class="col-6 row no-gutters modalContents__object05--payment02">
              <div class="col-md-2 col-sm-3 col-4">
                <input type="radio" name="payment" id="payment02" value="bank" v-model='payment_type'>
                <label for="payment02" aria-hidden="true"></label>
              </div>
              <label class="col-md-10 col-sm-9 col-8" for="payment02">
                <p class="text-left">銀行振込</p>
              </label>
            </div>
            <p class="col-12 text-right"><i>※銀行振込は最低2ヶ月からのご利用となります。</i></p>
            <p class="col-12 text-right"><i>※銀行振込の際の手数料はご負担願います。</i></p>

            <!-- カード支払いの場合 -->
            <div class="col-12 modalContents__object05--card" v-show="payment_type == 'credit'">
              <div class="row no-gutters">
                <div class="col-12">
                  <div style='text-align:center;' id="masterPaymentKeyPublic" ref="payjpArea">

                  </div>
                  <p v-if="errors.credittoken" class="error_message text-danger">{{ errors.credittoken }}</p>
                </div>
              </div>
            </div>

            <!-- 銀行支払いの場合 -->
            <div class="col-12 modalContents__object05--bank" v-show="payment_type == 'bank'" >
              <div class="row no-gutters">
                <!-- 振込名義人 -->
                <div class="col-12">
                  <label for="bankname">振込名義人（カタカナ）</label>
                  <input type="text" name="bankname" id="bankname" class="form-control" placeholder="ウエスギ タカシ">
                  <p v-if="errors.bankname" class="error_message text-danger">{{ errors.bankname }}</p>
                </div>
                <!-- 期間選択 -->
                <div class="col-12 row no-gutters">
                  <label class="col-12">期間選択</label>
                  <div class="col-7 mr-auto modalContents__object05--position01">
                    <div class="modalContents__object05--select">
                      <select name="bankmonth" id="bankmonth" class="form-control">
                        <option value="" selected>期間選択</option>
                        <option value="2">2ヶ月</option>
                        <option value="3">3ヶ月</option>
                        <option value="4">4ヶ月</option>
                        <option value="5">5ヶ月</option>
                        <option value="6">6ヶ月</option>
                        <option value="7">7ヶ月</option>
                        <option value="8">8ヶ月</option>
                        <option value="9">9ヶ月</option>
                        <option value="10">10ヶ月</option>
                        <option value="11">11ヶ月</option>
                        <option value="12">12ヶ月</option>
                      </select>
                    </div>
                    <p v-if="errors.bankmonth" class="error_message text-danger">{{ errors.bankmonth }}</p>
                  </div>
                </div>
              </div>
            </div>


            <!-- 戻るボタン -->
            <div class="col-4 modalContents__object05--position01">
              <button class="text-center btn modalContents__object05--back globalModal--btn" @click='back'
                type="submit">戻る</button>
            </div>
            <!-- 次へボタン -->
            <div class="col-6 offset-2">
              <button id="signup03_btn" class="text-center btn globalModal--btn" @click='send'
                type="submit">確認</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MultiModalMixin from '../mixins/ModalMixin'

//var PayjpCheckout = require('vue-payjp-checkout')

export default {
  name: 'payment',
  data : function(){
    return {
      script:'',

      payment_type : '',
      isCreditRenderded : false,
      errors:{
        none : '',
        credittoken : '',
        bankname : '',
        bankmonth : '',
      },
      isLogged: OPED.isLogged,
    }
  },
  mixins: [MultiModalMixin],

  created () {
    // HTML描画を待って要素をappendしたい
    setTimeout(() => {
      this.appendPayJpScriptTag()
    }, 1000)

    // appendPayJpScriptTagでscriptタグをappendとpayjpのscript実行後に処理したい
    setTimeout(() => {
      window.onTokenCreated = this.onTokenCreated
      window.onTokenFailed = this.onTokenFailed
    }, 1000)
  },

  beforeDestroy () {
    const payjpCheckoutIframeEl = document.getElementById('payjp-checkout-iframe')
    payjpCheckoutIframeEl.parentElement.remove()
    this.$refs.payjpArea.removeChild(this.scriptEl)
    window.PayjpCheckout = null
    window.onTokenCreated = null
    window.onTokenFailed = null
  },


  methods : {
    send(e){
      this.errors.none = ''
      this.errors.credittoken = ''
      this.errors.bankname = ''
      this.errors.bankmonth = ''
      if(this.payment_type == 'credit'){
        if(!$('[name="payjp-token"]').val()){
          this.errors.credittoken = 'カード情報をご入力ください'
        }
      }else if(this.payment_type == 'bank'){
        if(!$('#bankname').val()){
          this.errors.bankname = 'お振込時のご名義は必ずご入力ください'
        }else{
          if(!this.isZenKatakana($('#bankname').val())){
            this.errors.bankname = 'お振込時のご名義は必ず全角カタカナでご入力ください'
          }
        }
        if(!$('#bankmonth').val()){
          this.errors.bankmonth = 'ご契約期間は必ずご選択ください'
        }
      }else{
        this.errors.none = 'お支払い方法をご選択ください。'
      }

      if(!this.hasError()){
        //this.showConfirm();
        if(!this.isLogged){
          this.$store.state.inputData.payment_type = this.payment_type;
          if(this.payment_type == 'credit'){
            this.$store.state.inputData.payment_token = $('[name="payjp-token"]').val();
          }
          if(this.payment_type == 'bank'){
            this.$store.state.inputData.bank_name = $('#bankname').val();
            this.$store.state.inputData.bank_month = $('#bankmonth').val();
          }

          this.showModalRegistConfirm();
        }else{
          this.$store.state.inputData.payment_type = this.payment_type;
          if(this.payment_type == 'credit'){
            this.$store.state.inputData.payment_token = $('[name="payjp-token"]').val();
          }
          if(this.payment_type == 'bank'){
            this.$store.state.inputData.bank_name = $('#bankname').val();
            this.$store.state.inputData.bank_month = $('#bankmonth').val();
          }
          this.showModalEditPlanConfirm();
        }
      }

      e.preventDefault();
    },
    back(e){
      this.showModalPlan();
      e.preventDefault();
    },

    hasError(){
      var isError = false;
      for(var err in this.errors){
        if(this.errors[err]){
          isError = true;
        }
      }
      return isError;
    },

    isZenKatakana(str){
      str = (str==null)?"":str;
      if(str.match(/^[ァ-ヶー　 ]*$/)){    //"ー"の後ろの文字は全角スペースです。
        return true;
      }else{
        return false;
      }
    },

    appendPayJpScriptTag () {
      const attrs = {
        'id': 'payjp-script',
        'src': 'https://checkout.pay.jp/',
        'class': 'payjp-button',
        'data-key': OPED.PAYMENT_KEY,
        'data-partial': true,
        'data-text': 'カードのご登録',
        'data-submit-text': 'こちらのカードを登録する',
        'data-lang': 'ja',
        'data-on-created': 'onTokenCreated',
        'data-on-failed': 'onTokenFailed',
        'data-name-placeholder': 'YAMADA TARO'
      }
      this.scriptEl = document.createElement('script')
      for (const key in attrs) {
        this.scriptEl.setAttribute(key, attrs[key])
      }
      this.$refs.payjpArea.appendChild(this.scriptEl)
    },
    onTokenCreated () {
      const token = document.getElementsByName('payjp-token')
      // 処理
    },
    onTokenFailed (res) {
      // 処理
    }
  },

  mounted () {
    // this.script = document.createElement('script')
    // this.script.setAttribute('src', 'https://checkout.pay.jp/')
    // // this.script.setAttribute('data-on-created', 'payjpCheckoutOnCreated')
    // // this.script.setAttribute('data-on-failed', 'payjpCheckoutOnFailed')
    // this.script.setAttribute('data-key', 'pk_test_f758b9d394baabd594c44f50')
    // this.script.setAttribute('class', 'payjp-button')
    // this.script.setAttribute('data-partial', 'true')
    // this.script.setAttribute('data-text', 'カードのご登録')
    // this.script.setAttribute('data-submit-text', 'こちらカードを登録する')
    // this.$el.querySelector('#masterPaymentKeyPublic').appendChild(this.script);
  },


  watch : {
    payment_type(val){
      // if(val == 'credit' && !this.isCreditRenderded){
      //   const scriptEl = document.createElement('script');
      //   // https://pay.jp/docs/checkout
      //   const attrs = {
      //     src: 'https://checkout.pay.jp/',
      //     class: 'payjp-button',
      //     'data-key': 'pk_test_f758b9d394baabd594c44f50',
      //     'data-partial': true,
      //     'data-text': 'カードのご登録',
      //     'data-submit-text': 'こちらカードを登録する',
      //   };
      //   Object.keys(attrs).forEach(key => {
      //     const value = attrs[key];
      //     if (value !== undefined) {
      //       scriptEl.setAttribute(key, value);
      //     }
      //   });
      //   this.isCreditRenderded = true;
      //   setTimeout(function(){
      //     $('#masterPaymentKeyPublic').empty().html('');
      //     $('#masterPaymentKeyPublic').html(scriptEl);

      //     // setTimeout(function(){
      //     //   if(!$('#payjp_checkout_box').length){
      //     //     $('#masterPaymentKeyPublic').append('<div id="payjp_checkout_box"><input type="button" value="カードのご登録"><input type="hidden" name="payjp-token"></div>');
      //     //   }
      //     // },1000)
      //   },5);
      // }
    }
  }

  /*
  <div id="payjp_checkout_box"><input type="button" value="カードのご登録"><input type="hidden" name="payjp-token"></div>
  */

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/payment.vue